import React from 'react';
import './header.css';
import mural from '../../assets/lcpt-mural.jpeg';

const Header = () => {
  return (
    <div className="gpt3__header section__padding" id="home">
        <div className="gpt3__header-content">
          <p className="gpt3__header-eyebrow">Crown Point, NY - Physical Therapy</p>
          <h1 className="gradient__text">Personalized rehab near Lake Champlain.</h1>
          <p>Lake Champlain Physical Therapy provides a full range of physical rehab services for Southern Essex County and the greater Ticonderoga area with hands-on care, state-of-the-art equipment, and practical home programs.</p>

          <div className="gpt3__header-phone">
            <span>Call to schedule</span>
            <a href="tel:+15185974678">(518) 597-4678</a>
          </div>
        </div>
        <div className="gpt3__header-image">
          <img src={mural} alt="Lake Champlain Physical Therapy wall mural" />
        </div>
    </div>
  )
}

export default Header
